import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

/**
 * @description - 숫자에 천 단위 구분 기호를 추가하는 함수
 * @returns - 천 단위 구분 기호가 추가된 문자열
 */
export const numberWithCommas = (x: number) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/**
 * @param dateString - '2023-10-01 12:00:00' 형식의 날짜 문자열
 * @param formatString - 날짜를 포맷팅할 형식 문자열 (예: 'MMMM do, yyyy')
 * @returns - 지정된 형식의 날짜 문자열
 * @description - 날짜 문자열을 파싱하여 브라우저 로컬 타임존에 맞게 포맷팅하는 함수
 */
export const formatUtcToLocal = (
  utcDateString: string,
  formatString: string = 'MMMM do, yyyy HH:mm:ss'
): string => {
  if (!utcDateString) return '-';

  // UTC 날짜 문자열 -> Date 객체
  const utcDate = new Date(utcDateString);
  // debugger;

  // 브라우저의 로컬 타임존
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // UTC 날짜 -> 로컬 타임존
  const zonedDate = toZonedTime(utcDate, timeZone);

  return format(zonedDate, formatString);
};
